import {inlineError, streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class UnsubscribeUserAlertsUseCase extends UseCase {
  constructor({repository}) {
    super()
    this._repository = repository
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @inlineError
  execute({alertId, userId, unsubscribeToken}) {
    return this._repository.unsubscribeAlert({
      alertId,
      unsubscribeToken,
      userId
    })
  }
}

export default UnsubscribeUserAlertsUseCase
